import { ChevronLeft } from 'lucide-react';
import { C } from '../constants';
import FontStyles from './FontStyles';
import Confetti from './Confetti';
import CountdownPill from './CountdownPill';
import AnonymousBadge from './AnonymousBadge';
import SiteFooter from './SiteFooter';
import SubscribeCTA from './SubscribeCTA';
import SiteHeader from './SiteHeader';

export default function PageWrapper({
  children,
  confetti,
  confettiColor,
  onChangeState,
  countdown,
  stateData,
  published,
}) {
  const accent = stateData?.accent || C.cyan;

  const rightSlot = (
    <div className="flex items-center gap-2 flex-wrap">
      {onChangeState && (
        <button
          onClick={onChangeState}
          className="inline-flex items-center gap-1.5"
          style={{
            background:           C.cardBg,
            border:               `1px solid ${C.border}`,
            padding:              '5px 12px',
            borderRadius:         999,
            fontSize:             '0.73rem',
            fontWeight:           600,
            color:                C.textDim,
            cursor:               'pointer',
            backdropFilter:       'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            letterSpacing:        '0.04em',
            transition:           'border-color 180ms ease, color 180ms ease',
            fontFamily:           "'Poppins', sans-serif",
            whiteSpace:           'nowrap',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = accent; e.currentTarget.style.color = C.white; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.textDim; }}
        >
          <ChevronLeft size={12} />
          Switch state
        </button>
      )}
      {!published && <CountdownPill {...countdown} />}
    </div>
  );

  return (
    <div
      style={{
        background:           C.bg,
        minHeight:            '100vh',
        color:                C.white,
        fontFamily:           "'Poppins', sans-serif",
        backgroundImage:
          'radial-gradient(ellipse at 0% 0%, rgba(0,229,255,0.10) 0%, transparent 45%), ' +
          'radial-gradient(ellipse at 100% 100%, rgba(255,77,158,0.10) 0%, transparent 45%), ' +
          'radial-gradient(ellipse at 50% 30%, rgba(120,90,255,0.06) 0%, transparent 50%)',
        backgroundAttachment: 'fixed',
        position:             'relative',
        overflow:             'hidden',
      }}
    >
      <FontStyles />
      <Confetti active={confetti} partyColor={confettiColor} />

      <SiteHeader
        subtitle={stateData ? `— ${stateData.name}` : undefined}
        right={rightSlot}
      />

      {/* Disclaimer + state badge strip */}
      <div
        className="px-5 md:px-10 py-2.5 flex items-center justify-between gap-3 flex-wrap relative z-10"
        style={{ background: 'rgba(255,255,255,0.02)', borderBottom: `1px solid ${C.border}` }}
      >
        <div className="flex items-center gap-3 flex-wrap">
          {stateData && (
            <span style={{
              fontSize:      '0.68rem',
              fontFamily:    stateData.localFont,
              color:         accent,
              fontWeight:    600,
              letterSpacing: '0.02em',
            }}>
              {stateData.nameLocal}
            </span>
          )}
          <span style={{ fontSize: '0.7rem', color: C.textDim, fontStyle: 'italic', letterSpacing: '0.01em' }}>
            Unofficial · non-political · entertainment only.{stateData && ` ${stateData.strings.disclaimer}`}
          </span>
        </div>
        <AnonymousBadge size="sm" />
      </div>

      <div className="relative z-10">{children}</div>

      <SubscribeCTA
        theme="dark"
        title="Get State Election Updates"
        subtitle="We'll notify you when results go live and new states are added."
        source={stateData?.id || 'state'}
      />
      <SiteFooter />
    </div>
  );
}
